import { render, staticRenderFns } from "./LoyaltyCardTypeForm.vue?vue&type=template&id=dba80e36&"
import script from "./LoyaltyCardTypeForm.vue?vue&type=script&lang=js&"
export * from "./LoyaltyCardTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports